export default class imageDirectory {
    constructor() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var dropArea = element[0];

                dropArea.addEventListener('dragover', (e) => {
                    e.preventDefault();
                    $(element).children().addClass("directory-drop-active");
                });

                dropArea.addEventListener('dragleave', (e) => {
                    e.preventDefault();
                    $(element).children().removeClass("directory-drop-active");
                });

                dropArea.addEventListener('drop', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    if (e.dataTransfer) {
                        var imgId = e.dataTransfer.getData('text');
                        var dirId = $(element).attr('data-id');
                        
                        if (imgId) {
                            scope.$emit('imageBank:moveImage', { imgId: imgId, dirId: dirId });
                        } else if (e.dataTransfer.files.length) { // File drop from desktop
                            scope.$emit('imageBank:uploadImages', { files: e.dataTransfer.files, dirId: dirId });
                        }
                    }
                    
                    $(element).children().removeClass("directory-drop-active");
                })

            }
        }
    }
};
